var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":"light","small":_vm.small,"label":""}},[_c('v-icon',{attrs:{"left":"","color":_vm.colour,"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm._f("toUCFirst")(_vm.type))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }